import { Component, OnInit } from '@angular/core';
import { IdentityService } from 'projects/bis-shared/src/lib/auth/identity.service';

@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.scss'],
})
export class SsoComponent implements OnInit {
  constructor(private identityService: IdentityService) {}

  ngOnInit() {
    setTimeout(() => {
      if (!this.identityService.isTokenValid()) {
        this.identityService.reset();
        this.identityService.forceLogout = true;
      }
      this.identityService.redirectToThirdPartyLogin();
    }, 1000);
  }
}
